package fr.frux.components

import androidx.compose.runtime.Composable

/**
 * Bannière « Installer Frux » telle que la plateforme hôte la propose : [playUrl] est la fiche
 * Play avec son `referrer`, [dismiss] referme la bannière et la mémorise sept jours.
 */
class InstallPrompt(
    val playUrl: String,
    val dismiss: () -> Unit,
)

/** État de la bannière sur la plateforme hôte. Null partout sauf sur le web, et hors arrivée par un lien. */
@Composable
expect fun rememberInstallPrompt(): InstallPrompt?
